module.exports = __webpack_public_path__ + "static/media/web-design-dev-black.a421a285.svg";